import React, { useEffect, useRef, useState } from "react";
import AppModal from "../organisms/CustomModal";
import copyIcon from "../../../assets/svg/copy.svg";
import Button from "../atoms/Button";
import FormInput from "./FormInput";
import axios from "axios";
import { BASE_URL } from "../../services/http";
import { connect } from "react-redux";
import { handleException } from "../../utils";
import moment from "moment";
import Dropdown from "./Dropdown";
import arrow_down from "../../assets/svg/arrow-down.svg";
import arrow_up from "../../assets/svg/arrow-up.svg";
import Alert from "./Alert";
import { CSVLink, CSVDownload } from "react-csv";
import Spinner from "./Spinner";
var XLSX = require("xlsx");

const exportSize = [10, 25, 50, 100, 200];

const ExportModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dropdown, setDropdown] = useState(false);
  const [selectSize, setSelectedSize] = useState("");
  const [pocketMode, setPocketMode] = useState("ALL");

  const dropdownRef = useRef<HTMLDivElement>(null);

  const defaultStartDate = moment().subtract("1", "days").format("DD-MM-YYYY");
  const defaultEndDateTwo = moment().format("DD-MM-YYYY");
  const defaultEndDate = Date();

  const handleSubmit = () => {
    if (props.exportType !== "BATCH" && startDate === "") {
      Alert("error", "Enter a valid start date");
    } else if (props.exportType !== "BATCH" && endDate === "") {
      Alert("error", "Enter a valid end date");
    } else if (props.exportType !== "BATCH" && startDate > endDate) {
      Alert("error", "Start date cannot exceed the End date");
    } else if (props.exportType !== "BATCH" && endDate > defaultEndDate) {
      Alert("error", "End date cannot exceed the present day");
    } else {
      const inputData = {
        start: startDate,
        end: endDate,
      };
      fetchAndExport(inputData);
    }
  };

  const fetchAndExport = async (inputData) => {
    const url =
      props.exportType === "TRANSACTION" && pocketMode === "ALL"
        ? "transaction/pocket-download"
        : props.csvUrl;

    setLoading(true);

    const finalURL =
      inputData.start && inputData.end === ""
        ? `${url}${url.includes("?") ? "&" : "?"}createdOnStartDate=${moment(inputData.start).format("DD-MM-YYYY")}`
        : inputData.start === "" && inputData.end
          ? `${url}${url.includes("?") ? "&" : "?"}createdOnEndDate=${moment(inputData.end).format("DD-MM-YYYY")}`
          : inputData.start && inputData.end
            ? `${url}${url.includes("?") ? "&" : "?"}createdOnStartDate=${moment(inputData.start).format("DD-MM-YYYY")}&createdOnEndDate=${moment(inputData.end).format("DD-MM-YYYY")}`
            : `${url}`;

    let dateStr = "";
    if (inputData.start || inputData.end) {
      const startStr = inputData.start ? moment(inputData.start).format("DD-MM-YYYY") : "";
      const endStr = inputData.end ? moment(inputData.end).format("DD-MM-YYYY") : "";
      if (startStr && endStr) {
        dateStr = `_${startStr}_to_${endStr}`;
      } else if (startStr) {
        dateStr = `_${startStr}`;
      } else if (endStr) {
        dateStr = `_to_${endStr}`;
      }
    }

    try {
      let res;

      if (props.exportBatch) {
        res = await axios.post(
          `${BASE_URL}${props.csvUrl}`,
          {
            size: selectSize || 1000,
            page: 1,
            ...(inputData.start && {
              startDate: moment(inputData.start).format("DD-MM-YYYY"),
            }),
            ...(inputData.end && {
              endDate: moment(inputData.end).format("DD-MM-YYYY"),
            }),
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${props.bearerToken}`,
              "Public-Key": `${props.publicKey}`,
            },
          },
        );
      } else {
        res = await axios.get(
          props.exportType === "BATCH"
            ? `${BASE_URL + finalURL}`
            : `${BASE_URL + finalURL}&size=${props.exportType !== "TRANSACTION" ? selectSize : 10000
            }&page=0`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${props.bearerToken}`,
              "Public-Key": `${props.publicKey}`,
            },
          },
        );
      }

      if (
        res.data.code === "error" ||
        (res.data.status && res.data.status !== "00")
      ) {
        setLoading(false);
        handleException(res.data.message);
      } else {
        const fetchedData = props.exportBatch
          ? res.data.data.content
          : props.exportType === "BATCH"
            ? res.data.data.transactions
            : res.data.data.content;

        if (fetchedData.length < 1) {
          setLoading(false);
          Alert("error", "Oops, Nothing to export here");
        } else {
          if (props.exportType === "TRANSACTION") {
            const csvData = fetchedData.map((row: any) => {
              return {
                DATE: moment(row?.createdAt).format("DD-MM-YYYY HH:mm:ss"),
                CREDITS:
                  row.transactionLeg === "CREDIT"
                    ? `${row?.transactionAmount?.replace(/\d(?=(\d{3})+\.)/g, "$&,")}`
                    : "",
                DEBITS:
                  row.transactionLeg === "DEBIT"
                    ? `${row?.transactionAmount?.replace(/\d(?=(\d{3})+\.)/g, "$&,")}`
                    : "",
                "TRANSACTION CURRENCY": row.transactionCurrency,
                ...(pocketMode === "CURRENT" && {
                  "POCKET BALANCE":
                    `${row?.availableBalanceAmount?.replace(/\d(?=(\d{3})+\.)/g, "$&,")}` ||
                    "-",
                }),
                "POCKET ID": row?.pocketId,
                "TRANSACTION REFERENCE": row.reference,
                "TREANSACTION ID": row?.transactionId || "-",
                "TRANSACTION TYPE": row?.transactionType,
                "TRANSACTION STATUS": row.transactionLeg,
                NARRATION: row?.description || "-",
                "TRANSACTION SOURCE:": row?.transactionSource || "-",
                "REASON:": row?.narration || "-",
                STATUS: row?.message,
              };
            });

            const filename = `${props.titleName}${dateStr}-file.xlsx`;
            var ws = XLSX.utils.json_to_sheet(csvData);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "transactions");
            XLSX.writeFile(wb, filename);

            setLoading(false);
            Alert("success", "Export completed successfully");
            props.toggleModal();
          } else if (props.exportBatch) {
            const csvData = fetchedData.map((row: any) => {
              const {
                processedCount = 0,
                totalTransactions = 0,
                failedCount = 0,
                pendingCount = 0,
              } = row;

              const isFullSuccess = processedCount === totalTransactions;
              const isPartial = processedCount > 0 && failedCount > 0;
              const isFailed = processedCount === 0 && pendingCount === 0;

              const status = isFullSuccess
                ? "Successful"
                : isPartial
                  ? "Partial"
                  : isFailed
                    ? "Failed"
                    : "Pending";

              return {
                DATE: moment(row?.createdAt).format("DD-MM-YYYY HH:mm:ss"),
                "BATCH ID": row?.batchId,
                TOTAL: row?.totalTransactions,
                PENDING: row?.pendingCount ?? 0,
                PROCESSED: row?.processedCount ?? 0,
                FAILED: row?.failedCount ?? 0,
                STATUS: status,
              };
            });

            const csvHeaders = Object.keys(csvData[0]).join(",");
            const csvRows = csvData.map((row) => {
              return Object.values(row)
                .map((value) => `"${String(value ?? "").replace(/"/g, '""')}"`)
                .join(",");
            });

            const csvContent = [csvHeaders, ...csvRows].join("\n");
            const blob = new Blob([csvContent], {
              type: "text/csv;charset=utf-8;",
            });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);

            link.setAttribute("href", url);
            link.setAttribute("download", `Batch-List-${props.titleName}${dateStr}.csv`);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setLoading(false);
            Alert("success", "Export completed successfully");
            props.toggleModal();
          } else if (props.exportType === "BATCH") {
            // Batch transactions CSV export
            const csvData = fetchedData.map((row: any) => {
              return {
                DATE: moment(row?.createdAt).format("DD-MM-YYYY HH:mm:ss"),
                "BATCH ID": row?.batchId,
                "TRANSACTION TYPE": row?.transactionType,
                "POCKET ID": row?.pocketId,
                "ACCOUNT NUMBER": row?.accountNumber,
                AMOUNT: row?.amount,
                CURRENCY: row?.currency,
                "PAYMENT REFERENCE": row?.reference,
                DESCRIPTION: row?.description,
                STATUS: row?.transactionStatus,
                REASON: row?.reason,
                "TRANSACTION SOURCE": row?.transactionSource,
              };
            });

            const csvHeaders = Object.keys(csvData[0]).join(",");
            const csvRows = csvData.map((row) => {
              return Object.values(row)
                .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
                .join(",");
            });

            const csvContent = [csvHeaders, ...csvRows].join("\n");
            const blob = new Blob([csvContent], {
              type: "text/csv;charset=utf-8;",
            });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);

            link.setAttribute("href", url);
            link.setAttribute(
              "download",
              `Batch-Transactions-${props.titleName.split(" - ")[1]}${dateStr}.csv`,
            );
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setLoading(false);
            Alert("success", "Export completed successfully");
            props.toggleModal();
          } else {
            const csvData = fetchedData.map((row: any) => row);

            const csvHeaders = Object.keys(csvData[0]).join(",");
            const csvRows = csvData.map((row) => {
              return Object.values(row)
                .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
                .join(",");
            });

            const csvContent = [csvHeaders, ...csvRows].join("\n");
            const blob = new Blob([csvContent], {
              type: "text/csv;charset=utf-8;",
            });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);

            link.setAttribute("href", url);
            link.setAttribute("download", `${props.titleName}${dateStr}-file.csv`);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setLoading(false);
            Alert("success", "Export completed successfully");
            props.toggleModal();
          }
        }
      }
    } catch (error) {
      setLoading(false);
      handleException(error);
    }
  };

  const formComplete =
    props.exportType === "BATCH"
      ? true
      : startDate !== "" && endDate !== "" && selectSize !== "";
  const disabledBtn = formComplete === false || loading === true;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(target) &&
        !target.closest(".shadow-md")
      ) {
        setDropdown(false);
      }
    };

    if (dropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdown]);

  const formattedTitle = props.titleName.includes("Overview")
    ? `Transactions Data For Batch Id - ${props.titleName.split(" - ")[1]}`
    : props.titleName;

  return (
    <AppModal
      handleClose={props.toggleModal}
      modalStyle="desktop:w-2/6 w-3/5 mobile:w-4/5 bg-white min-h-fit z-30 top-0 left-0 right-0 p-8 my-[10rem] mobile:my-[3rem] mx-auto animate-slide_down rounded-xl"
      contentStyle="overflow-y-scroll min-h-fit"
    >
      <div className="flex flex-col text-left mb-8">
        <span className="font-normal text-2xl mobile:text-lg text-black mb-5">
          Export to CSV
        </span>
        {props.exportType === "BATCH" ? (
          <span className="text-[14px] mobile:text-xs leading-7 text-SecondaryAccent">
            Export All {formattedTitle}.
          </span>
        ) : (
          <span className="text-[14px] mobile:text-xs leading-7 text-SecondaryAccent">
            Select date range to export all {props.titleName} data between
            selected range.
          </span>
        )}
      </div>

      <div className="min-h-fit flex flex-col gap-5 mobile:gap-2 justify-between">
        {props.exportType !== "BATCH" && (
          <div className="rounded-md flex mobile:flex-col flex-shrink gap-5 mobile:gap-2 w-full">
            <FormInput
              label="Start Date"
              labelStyle="text-GrayCustom7 text-xs"
              type="date"
              name="start_date"
              style="rounded-lg w-full"
              inputStyle={`${startDate === "" ? "text-GrayCustom" : "text-DarkBg3"
                } border`}
              value={startDate === "" ? defaultStartDate : startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <FormInput
              label="End Date"
              labelStyle="text-GrayCustom7 text-xs"
              type="date"
              name="end_date"
              style="rounded-lg w-full"
              inputStyle={`${endDate === "" ? "text-GrayCustom" : "text-DarkBg3"
                } border`}
              value={endDate === "" ? defaultEndDateTwo : endDate}
              onChange={(e) => setEndDate && setEndDate(e.target.value)}
            />
          </div>
        )}

        {props.exportType !== "BATCH" && (
          <div className="min-h-[7vh] mb-5" ref={dropdownRef}>
            <Dropdown
              data={exportSize}
              style="absolute -right-6 bottom-0 w-1/2 animate-slide_down"
              textStyle="text-sm"
              containerStyle="min-w-[200px] max-w-[300px]"
              dropdown={dropdown}
              handleSelect={setSelectedSize}
              setDropdown={setDropdown}
            >
              <FormInput
                label={`Select size to be exported`}
                labelStyle="text-GrayCustom7 text-xs"
                type="text"
                name="searchItem"
                placeholder={selectSize === "" ? "10" : selectSize}
                style="rounded-lg w-fit mobile:w-full"
                inputStyle="flex-row-reverse border cursor-pointer"
                img={dropdown ? arrow_up : arrow_down}
                imgStyle="w-4 h-4 cursor-pointer"
                imgOnClick={() => setDropdown((prevState) => !prevState)}
                value={selectSize}
                validationErr=""
                disabled={true}
                onChange={() => { }}
              />
            </Dropdown>
          </div>
        )}

        <div className="w-full flex flex-col gap-3">
          <Button
            btnType="button"
            btnText={
              loading ? (
                <Spinner
                  text={`Exporting ${props.exportType === "BATCH" ? "CSV" : "Data"} ${props.titleName} data...`}
                  textStyle="text-DarkBg3"
                />
              ) : (
                `Export ${props.exportType === "BATCH" ? "CSV" : "Data"}`
              )
            }
            btnStyle="px-3 py-2 font-semibold text-base leading-7 bg-SecondaryAccent5 text-DarkBg3 flex-row-reverse rounded-lg truncate w-full"
            disabled={disabledBtn}
            disabledClass="cursor-not-allowed bg-GrayCustom text-DarkBg3"
            onClick={handleSubmit}
          />
        </div>
      </div>
    </AppModal>
  );
};

const mapStateToProps = (state) => ({
  bearerToken: state.auth.token,
  publicKey: state.auth.public_key,
});

export default connect(mapStateToProps)(ExportModal);
